import Page, { PageContent } from 'core/Page'
import { ReactNode } from 'react'

type AuthLayoutProps = {
  children: ReactNode
}

const AuthLayout = (props: AuthLayoutProps) => {
  return (
    <Page className="h-screen">
      <PageContent>{props.children}</PageContent>
    </Page>
  )
}

export default AuthLayout
